<template>
	<div class="m-quota flex-column flex-grow">
		<div class="quota flex-grow flex-between">
			<template v-for="(group, i) in totalList">
				<template v-if="i == 1">
					<div v-for="(item, j) in group" :key="j" class="total flex-grow flex">
						<div class="bg flex-grow"></div>
						<div class="content flex-column flex-center">
							<div :style="{'color': `var(--color-${item.color})`}">{{item.data}}</div>
							<p>{{item.title}}</p>
						</div>
					</div>
				</template>
				<ul v-else class="flex-grow flex-column">
					<li v-for="(item, j) in group" :key="j" class="flex-column flex-center flex-grow">
						<div :style="{'color': `var(--color-${item.color})`}">{{item.data}}</div>
						<p>{{item.title}}</p>
					</li>
				</ul>
			</template>
		</div>
		<module v-if="notice">
			<div ref="noticeScroll" class="notice">
				<ul ref="noticeList" :scroll="noticeScroll" :style="{'transform': `translate(0,-${0.36 * noticeIndex}rem)`}">
					<li v-for="(data, i) in noticeList" :key="i" class="item flex">
						<div v-for="(item, j) in fieldList" :key="j" class="flex-center-cross" :style="{'flex-grow': item.width}">
							<template v-if="item.code == 'process_name'">
								{{data.product_code}} | {{data.process_name}}
							</template>

							<template v-else-if="item.code == 'fine_count'">
								良品数：<span style="color: #fff;">{{data.fine_count}}</span>
							</template>

							<template v-else-if="item.code == 'defects_count'">
								不良品数：<span style="color: #FF2A2A;">{{data.defects_count}}</span>
							</template>
							
							<template v-else-if="item.code == 'output_date'">{{parseDate(data[item.code], 'MM-dd hh:mm')}}</template>
							
							<template v-else>{{data[item.code]}}</template>
						</div>
					</li>
				</ul>
			</div>
		</module>
	</div>
</template>

<script>
	import module from './digital_module.vue'

	export default {
		components: {
			module
		},

		props: {
			id: [Number, String],
			notice: Boolean
		},

		data() {
			return {
				totalList: [],
				fieldList: [{
					code: 'output_user_name',
					width: 120
				}, {
					code: 'process_name',
					width: 250
				}, {
					code: 'fine_count',
					width: 120
				}, {
					code: 'defects_count',
					width: 140
				}, {
					code: 'output_date',
					width: 120
				}],
				noticeList: [],
				noticeIndex: 0,
				noticeScroll: false
			}
		},

		mounted() {
			this.update()
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
			clearTimeout(this._scrollTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						this.totalList = [];
						this.totalList.push(data.childModuleList.splice(0, 2));
						this.totalList.unshift(data.childModuleList.splice(0, 4));
						this.totalList.push(data.childModuleList.splice(0, 4));
						this.noticeList = data.output_list;
						this.$nextTick(() => {
							clearTimeout(this._scrollTimer);
							this.noticeScroll = false;
							if (this.$refs.noticeList.clientHeight > this.$refs.noticeScroll.clientHeight) {
								this.noticeList = this.noticeList.concat(this.noticeList);
								this.$nextTick(this.updateNotice);
							} else {
								this.$nextTick(() => {
									this.noticeIndex = 0;
								});
							}
						});
						this._updateTimer = setTimeout(this.update, 300000);
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 300000);
					}
				})
			},

			updateNotice() {
				this.$nextTick(() => {
					if (this.noticeIndex >= this.noticeList.length / 2) {
						this.noticeIndex = 0;
					}
				});

				!function loop() {
					this._scrollTimer = setTimeout(() => {
						this.noticeScroll = true;
						this.$nextTick(() => {
							this.noticeIndex++;
						});
						setTimeout(() => {
							this.noticeScroll = false;
							this.$nextTick(() => {
								if (this.noticeIndex >= this.noticeList.length / 2) {
									this.noticeIndex = 0;
								}
							});
						}, 500);
						loop.call(this);
					}, 6000);
				}.call(this)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-quota {
		flex-grow: 1.26;

		.module-box {
			margin-top: .15rem;
		}
	}

	.quota {
		position: relative;
		flex-grow: 2.8;

		&:before {
			content: '';
			position: absolute;
			top: 1.05rem;
			left: 20%;
			right: 20%;
			bottom: 0;
			background-image: url('~@/assets/image/digital/quota.png');
			background-size: 100% auto;
			background-repeat: no-repeat;
			background-position: center center;
		}

		ul {
			position: relative;
			border: 1px solid rgba(49,198,253,.9);
			background: rgba(49,198,253,.1);
			box-shadow: inset 0 0 .4rem 0 rgba(49,198,253,.3);

			&:nth-child(1) {
				border-radius: .12rem 0 0 .12rem;
			}

			&:nth-last-child(1) {
				border-radius: 0 .12rem .12rem 0;
			}

			&:nth-child(n+2) {
				margin-left: .1rem;
			}

			li {
				position: relative;
				margin: 0 .05rem;

				&:nth-child(n+2):before {
					content: '';
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					height: 1px;
					background: linear-gradient(90deg, rgba(0,255,255,.01), #00FFFF, rgba(0,255,255,.01));
				}

				div {
					font-size: .24rem;
					font-weight: 500;
					color: #fff;
				}

				p {
					margin-top: .1rem;
					font-size: .15rem;
					color: #5DD2FF;
				}
			}
		}

		.total {
			box-sizing: border-box;
			position: relative;
			height: 1.05rem;

			&:nth-child(n+2) {
				margin-left: .1rem;
			}
			
			&:before,
			&:after {
				content: '';
				width: .475rem;
				height: 100%;
				background-image: url('~@/assets/image/digital/total_bg_left.png');
				background-size: calc(100% + 1px) 100%;
			}
			
			&:before {
				background-image: url('~@/assets/image/digital/total_bg_left.png');
			}
			
			&:after {
				background-image: url('~@/assets/image/digital/total_bg_right.png');
				background-position: right top;
			}
			
			.bg {
				height: 100%;
				background-image: url('~@/assets/image/digital/total_bg.png');
				background-size: 100% 100%;
			}
			
			.content {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				padding-top: .1rem;

				div {
					font-size: .24rem;
					font-weight: 500;
					color: #fff;
				}

				p {
					margin-top: .1rem;
					font-size: .15rem;
					color: #5DD2FF;
				}
			}
		}
	}
	
	.notice {
		height: 100%;
		margin: 0 -.1rem;
		overflow: hidden;

		ul {
			&[scroll] {
				transition: transform .5s ease;
			}
		}

		li {
			padding: 0 .1rem;

			&:nth-child(even) {
				background: rgba(255,255,255,.1);
			}

			div {
				width: 0;
				height: .36rem;
				line-height: .18rem;
				font-size: .14rem;
				color: #5DD2FF;

				&:nth-child(n+2) {
					margin-left: .05rem;
				}
			}
		}
	}
</style>
